export const selectMenuPortalProps = {
  menuPortalTarget: typeof document !== "undefined" ? document.body : null,
  menuPosition: "fixed",
};

const menuPortalStyle = (base) => ({
  ...base,
  zIndex: 9999,
});

export function creatableStyleSingle(theme) {
  return {
    control: (base, state) => ({
      ...base,
      minHeight: "32px",
      height: "32px",
      borderColor: "#d1d5db",
      borderRadius: "0.5rem",
      boxShadow: state.isFocused ? "0 0 0 1px #db2777" : "none",
      "&:hover": {
        borderColor: "#d1d5db",
      },
    }),
    valueContainer: (base) => ({
      ...base,
      height: "32px",
      padding: "0 8px",
      fontSize: "13px",
    }),
    input: (base) => ({
      ...base,
      margin: 0,
      padding: 0,
      fontSize: "13px",
    }),
    placeholder: (base) => ({
      ...base,
      fontSize: "13px",
    }),
    singleValue: (base) => ({
      ...base,
      fontSize: "14px",
      fontWeight: "500",
    }),
    indicatorsContainer: (base) => ({
      ...base,
      height: "32px",
    }),
    indicatorSeparator: () => ({
      display: "none",
    }),
    dropdownIndicator: (base) => ({
      ...base,
      padding: "0 8px",
    }),
    clearIndicator: (base) => ({
      ...base,
      padding: "0 8px",
    }),
    menu: (base) => ({
      ...base,
      fontSize: "13px",
    }),
    menuPortal: menuPortalStyle,
  };
}

export function creatableStyleMulti(theme) {
  return {
    control: (base, state) => ({
      ...base,
      minHeight: "32px",
      borderColor: "#d1d5db",
      borderRadius: "0.5rem",
      boxShadow: state.isFocused ? "0 0 0 1px #db2777" : "none",
      "&:hover": {
        borderColor: "#d1d5db",
      },
    }),
    valueContainer: (base) => ({
      ...base,
      padding: "0 8px",
      fontSize: "13px",
    }),
    input: (base) => ({
      ...base,
      margin: 0,
      padding: 0,
      fontSize: "13px",
    }),
    placeholder: (base) => ({
      ...base,
      fontSize: "13px",
    }),
    multiValue: (base) => ({
      ...base,
      backgroundColor: "rgba(55, 65, 81, 1)",
      borderRadius: "0.25rem",
      margin: "2px",
    }),
    multiValueLabel: (base) => ({
      ...base,
      fontSize: "13px",
      padding: "2px 6px",
      color: "white",
    }),
    multiValueRemove: (base) => ({
      ...base,
      borderRadius: "0 0.25rem 0.25rem 0",
      color: "white",
      ":hover": {
        backgroundColor: "#1d4ed8",
        color: "white",
      },
    }),
    indicatorsContainer: (base) => ({
      ...base,
      height: "32px",
    }),
    indicatorSeparator: () => ({
      display: "none",
    }),
    dropdownIndicator: (base) => ({
      ...base,
      padding: "0 8px",
    }),
    clearIndicator: (base) => ({
      ...base,
      padding: "0 8px",
    }),
    menu: (base) => ({
      ...base,
      fontSize: "13px",
    }),
    menuPortal: menuPortalStyle,
  };
}
